<template>
  <nav class="navbar fixed-top" v-if="data" v-cloak>
    <!-- <dev> -->
    <div class="dropdown" v-if="env === 'dev' || env === 'qa'" @keyup.q="devPrePopulate()">
      <button class="btn btn-dev btn-sm btn-secondary dropdown-toggle"
        type="button" data-toggle="dropdown">{{env}}</button>
      <ul class="dropdown-menu" v-if="!dev.jwtSet" style="padding: 20px">
        <input class="form-control form-control-sm" type="text" placeholder="ssn"
          v-model="dev.ssn" pattern="\d*" />
        <input class="form-control form-control-sm" type="text" placeholder="firstname"
          v-model="dev.firstname" />
        <input class="form-control form-control-sm" type="text" placeholder="lastname"
          v-model="dev.lastname" @keyup.enter="devGetJwt()" />
        <div class="clearfix"></div>
        <button class="btn btn-secondary btn-dev btn-sm btn-block"
          @click="devGetJwt()" :disabled="!dev.ssn || !dev.firstname || !dev.lastname">get JWT</button>
        <button class="btn btn-warning btn-dev btn-sm btn-block"
          @click="dev.jwtSet = !dev.jwtSet">skip</button>
      </ul>
      <ul class="dropdown-menu" v-if="dev.jwtSet">
        <li>
          <button class="cursor-pointer"
            @click="devSetFakeCredentialsWithRoute('consent')">consent</button>
        </li>
        <li>
          <button class="cursor-pointer"
            @click="devSetFakeCredentialsWithRoute('consentpath')">service</button>
        </li>
        <li>
          <button class="cursor-pointer"
            @click="devSetFakeCredentialsWithRoute('nextstep')">nextStep</button>
        </li>
        <li>
          <button disabled
            @click="devSetFakeCredentialsWithRoute('survey')"><s>survey</s></button>
        </li>
        <li>
          <button disabled
            @click="devSetFakeCredentialsWithRoute('optout')"><s>optout</s></button>
        </li>
        <li>
          <button class="cursor-pointer"
            @click="devSetFakeCredentialsWithRoute('clear')">clear storages</button>
        </li>
      </ul>
    </div>
    <!-- </dev> -->
    <!-- Dev/QA Handheld -->
    <div class="text-left" v-if="isPhone">
      <span @click="setHrefAndRoute()" class="router-link cursor-pointer">
        <span class="img-logo" v-if="env !== 'prod'">Diabetessupporten</span>
      </span>
    </div>
    <!-- Prod Handheld -->
    <div @click="setHrefAndRoute()" class="text-center router-link cursor-pointer"
      v-if="(env === 'prod') && isPhone">
      <span class="img-logo">Diabetessupporten</span>
    </div>
    <img
      v-if="isPhone"
      src="@/assets/img/hamburger.svg?data"
      alt="Ikon för hamburgarmeny"
      class="navbar-toggler img-fluid"
      data-toggle="collapse"
      data-target="#collapsibleNavbar"
    />
    <!-- Dev/QA Desktop -->
    <div class="row" v-if="!isPhone">
      <div class="col-md-4"></div>
      <div class="col-md-8">
        <span @click="setHrefAndRoute()" class="router-link cursor-pointer">
          <span class="img-logo" v-if="env !== 'prod'">Diabetessupporten</span>
        </span>
      </div>
      <div class="col-sm"></div>
    </div>
    <!-- Prod Desktop -->
    <div class="d-flex justify-content-center router-link cursor-pointer"
      style="margin-left: -5vw" v-if="(env === 'prod') && !isPhone" @click="setHrefAndRoute()">
      <span class="img-logo">Diabetessupporten</span>
    </div>
    <!-- Desktop -->
    <div class="pull-right" v-if="!isPhone">
      <li class="nav-item">
        <router-link
          class="nav-link text-white"
          :to="{ name: 'faq', params: { page: pages.aboutapp } }">
        {{ data.misc.aboutLabel }}
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link text-white"
          :to="{ name: 'faq', params: { page: pages.cookies } }">
        {{ data.misc.cookiesLabel }}
        </router-link>
      </li>
    </div>
    <!-- Handheld -->
    <div class="collapse navbar-collapse" id="collapsibleNavbar" v-if="isPhone">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link
              class="nav-link text-white"
              :to="{ name: 'faq', params: { page: pages.aboutapp } }">
            {{ data.misc.aboutLabel }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link text-white"
              :to="{ name: 'faq', params: { page: pages.cookies } }">
            {{ data.misc.cookiesLabel }}
            </router-link>
          </li>
        </ul>
      </div>
  </nav>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'
import { parseJwt } from '../plugins/jwtparser'
import { v4 as uuidv4 } from 'uuid'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'top',
  data () {
    return {
      data: null,
      env: process.env.NODE_ENV,
      pages: {
        aboutapp: 'aboutapp',
        cookies: 'cookies'
      },
      dev: {
        jwtSet: false,
        firstname: '',
        lastname: '',
        ssn: ''
      },
      isPhone: isMobile
    }
  },
  methods: {
    devPrePopulate () {
      this.dev.firstname = 'Sebastian'
      this.dev.lastname = 'Degerman'
      this.dev.ssn = '198910120396'
    },
    devGetJwt () {
      if (this.dev.ssn && this.dev.firstname && this.dev.lastname) {
        let loader = this.$loading.show({
          default: showDelayText(config.delayText, config.delayTimer)
        })
        const temp = {
          ssn: this.dev.ssn,
          firstname: this.dev.firstname,
          lastname: this.dev.lastname
        }
        sessionStorage.setItem('temp', JSON.stringify(temp))
        axios.postTokenTest(config.tokenUri + config.testUri, temp).then((response) => {
          if (response.status === 200) {
            sessionStorage.setItem('jwt', response.data)

            const djwt = parseJwt(response.data)
            this.$store.commit('setName', djwt.givenName + ' ' + djwt.surName)
            sessionStorage.setItem('userFullName', djwt.givenName + ' ' + djwt.surName)

            loader.hide()
            this.$notify({
              group: 'general',
              type: 'success',
              title: 'Success',
              text: 'JWT granted'
            })

            this.dev.jwtSet = true
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'Error',
              text: 'Try again'
            })
          }
        })
      }
    },
    devSetFakeCredentialsWithRoute (route) {
      sessionStorage.setItem('devSession', true)
      if (!sessionStorage.getItem('userLoggedIn')) {
        this.$store.commit('setLogin', true)
        sessionStorage.setItem('userLoggedIn', true)
      }
      if (!sessionStorage.getItem('userFullName')) {
        this.$store.commit('setName', 'Test Testsson')
        sessionStorage.setItem('userFullName', 'Test Testsson')
      }
      switch (route) {
        case 'consent':
          sessionStorage.setItem('sessionId', uuidv4().replaceAll('-', ''))
          this.$router.push('/consent')
          break
        case 'consentpath':
          this.$router.push('/consentpath')
          break
        case 'nextstep':
          const paths = ['radio_calls_sms', 'radio_1177']
          sessionStorage.setItem('path', paths[Math.floor(Math.random() * paths.length)])
          this.$router.push('/nextstep')
          break
        case 'survey':
          this.$router.push({path: 'survey', query: { questions: '119546605,119542226,119642358,132813328' }})
          break
        case 'optout':
          this.$router.push('/optout')
          break
        case 'clear':
          this.$store.commit('setLogin', false)
          this.$store.commit('setName', null)
          localStorage.clear()
          sessionStorage.clear()
          location.reload()
          break
        default:
          break
      }
    },
    setHrefAndRoute () {
      if (this.$store.getters.getLogin || sessionStorage.getItem('userLoggedIn')) {
        window.location.href = window.location.origin.concat('/consent')
      } else {
        window.location.href = window.location.origin.concat('/login')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            toStartBtn
            aboutLabel
            cookiesLabel
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
nav {
  background: #001965 !important;
}
.dropdown-menu > li > button {
  margin: 5px;
}
.disabled-href {
  pointer-events: none;
}
.router-link {
  z-index: 999 !important;
}
.img-logo {
  width: 2vw;
  color: #fff;
  font-size: 2rem;
  letter-spacing: .1em;
  margin-left: .1vw;
  vertical-align: bottom;
  line-height: 50px;
}
.btn-dev {
  border-radius: 5px !important;
}
.btn-dev:disabled {
  opacity: 0.3;
}
.vue-notification-group {
  margin-top: 5px !important;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .img-logo {
    font-size: 1.4em;
  }
  .nav-item {
    text-align: right;
    font-size: 80%;
    padding: .2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue